"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var styles = function styles(theme) {
  return {
    root: {
      position: "relative",
      flex: 1,
      width: "100%",
      height: "100%",
      minHeight: 400,
      overflow: "hidden"
    },
    map: {}
  };
};

var _default = styles;
exports["default"] = _default;